export const FILTERS_API = '/config/v2/screenconfigurations';
